import { useEffect, useState } from "react";
import { Loader2, Gift, CheckCircle2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import api from "@/lib/api";
import { toast } from "sonner";

// variant: "full" (section/page hero) or "compact" (footer)
export default function FreeGuideSignup({ variant = "full" }) {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [info, setInfo] = useState(null);

  useEffect(() => {
    api.get("/free-guide/info").then((r) => setInfo(r.data)).catch(() => {});
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      await api.post("/subscribe", { email: email.trim(), origin_url: window.location.origin });
      setDone(true);
      toast.success("Almost there — check your inbox to confirm!");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Something went wrong. Please try again.");
    } finally { setBusy(false); }
  };

  const compact = variant === "compact";

  if (done) {
    return (
      <div data-testid={`free-guide-success-${variant}`} className={`flex items-start gap-3 ${compact ? "" : "border border-primary/30 bg-primary/5 rounded-xl p-5"}`}>
        <CheckCircle2 className="w-5 h-5 text-primary shrink-0 mt-0.5" />
        <div>
          <p className={`font-display ${compact ? "text-base" : "text-lg"}`}>Check your email</p>
          <p className="text-sm text-muted-foreground mt-0.5">
            We sent a confirmation link to <span className="text-foreground">{email}</span>. Click it and your free guide is on the way.
          </p>
        </div>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid={`free-guide-form-${variant}`} className={compact ? "space-y-2" : "space-y-3"}>
      <div className={`flex flex-col sm:flex-row gap-2 ${compact ? "" : "max-w-md"}`}>
        <Input
          type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com" data-testid={`free-guide-email-${variant}`}
          className="h-11 flex-1 bg-background" />
        <Button type="submit" disabled={busy} data-testid={`free-guide-submit-${variant}`}
          className="h-11 rounded-full font-mono-label text-[11px] px-6 whitespace-nowrap">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Gift className="w-4 h-4 mr-1.5" /> Get it free</>}
        </Button>
      </div>
      <p className={`text-[11px] text-muted-foreground ${compact ? "" : ""}`}>
        Confirm your email and we'll send the download. No spam, unsubscribe anytime.
      </p>
    </form>
  );
}
